import controllerJSON from './Controller.json';

const contract = require('@truffle/contract');

export default contract({
  abi: controllerJSON.abi,
});
